import React, { useEffect, useState } from 'react';
import { Button, Card, CardContent, TablePagination } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import MUIDataTable from 'mui-datatables';
import { Delete, Edit } from '@material-ui/icons';
import CustomeSearch from '../../../components/CustomSearch';
import ActiveFilter from '../../../components/ActiveFilter';
import DeleteDialog from '../../../components/DeleteDialog';
import NewSafetyProject from '../NewSafetyProject';
import { fetchSafetyProjects, removeSafetyProject } from '../../../redux/actions/safety';

const List = () => {
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const [selectedId, setSelectedId] = useState('');
  const [isNewOpen, setIsNewOpen] = useState(false);
  const [project, setProject] = useState(null);
  const [filterState, setFilterState] = useState({ isActive: '' });

  const dispatch = useDispatch();
  const { safetyProjects } = useSelector(({ safety }) => safety);

  const getFilterObj = (values) => ({
    isActive: values.isActive === '' ? undefined : values.isActive
  });

  useEffect(() => {
    dispatch(fetchSafetyProjects({ page: 1, pageSize: 100, ...getFilterObj(filterState) }));
  }, []);

  const pageChange = (page) => {
    dispatch(
      fetchSafetyProjects({
        page,
        pageSize: safetyProjects?.pageSize || 100,
        ...getFilterObj(filterState)
      })
    );
  };

  const pageSizeChange = (pageSize) => {
    dispatch(
      fetchSafetyProjects({
        page: safetyProjects?.page || 1,
        pageSize,
        ...getFilterObj(filterState)
      })
    );
  };

  const columns = [
    { name: 'name', label: 'Project Name' },
    { name: 'description', label: 'Description' },
    {
      name: 'isActive',
      label: 'Status',
      options: {
        customBodyRender: (value) => (value ? 'Active' : 'Inactive')
      }
    },
    {
      name: 'id',
      label: 'Actions',
      options: {
        customBodyRender: (value) => (
          <>
            <Edit
              style={{ cursor: 'pointer' }}
              color="primary"
              onClick={() => {
                setProject(safetyProjects?.data.find((p) => p.id === value));
                setIsNewOpen(true);
              }}
            />
            <Delete
              style={{ color: 'red', cursor: 'pointer' }}
              onClick={() => {
                setSelectedId(value);
                setIsDeleteOpen(true);
              }}
            />
          </>
        )
      }
    }
  ];

  const filter = (values) => {
    setFilterState(values);
    dispatch(fetchSafetyProjects({ page: 1, pageSize: 100, ...getFilterObj(values) }));
  };

  return (
    <Card className="userlist">
      <ActiveFilter onFilter={filter} initialFormState={filterState} />
      <CardContent>
        <div className="userlist__header">
          <Button size="medium" color="primary" variant="contained" onClick={() => setIsNewOpen(true)}>
            New Safety Project
          </Button>
        </div>
        <MUIDataTable
          title="Safety Projects"
          data={safetyProjects?.data || []}
          columns={columns}
          options={{
            filterType: 'textField',
            responsive: 'standard',
            selectableRows: 'none',
            pagination: false,
            elevation: 0,
            customSearchRender: (searchText, handleSearch, hideSearch) => (
              <CustomeSearch handleSearch={handleSearch} hideSearch={hideSearch} />
            ),
            customFooter: () => (
              <tbody>
                <tr>
                  <TablePagination
                    rowsPerPage={safetyProjects?.pageSize || 100}
                    count={safetyProjects?.count || 0}
                    page={safetyProjects?.page ? safetyProjects.page - 1 : 0}
                    onPageChange={(event, page) => pageChange(page + 1)}
                    onRowsPerPageChange={(event) => pageSizeChange(event.target.value)}
                    rowsPerPageOptions={[10, 20, 40, 80, 100]}
                  />
                </tr>
              </tbody>
            ),
            print: false,
            viewColumns: false
          }}
        />
      </CardContent>

      <DeleteDialog
        open={isDeleteOpen}
        handleClose={() => {
          setIsDeleteOpen(false);
          setSelectedId('');
        }}
        handleOk={() => {
          dispatch(removeSafetyProject(selectedId));
          setIsDeleteOpen(false);
          setSelectedId('');
        }}
        message="Are you sure you want to delete this safety project?"
      />
      {isNewOpen && (
        <NewSafetyProject
          open={isNewOpen}
          project={project}
          handleClose={() => {
            setIsNewOpen(false);
            setProject(null);
          }}
          handleOk={() => {
            setIsNewOpen(false);
            setProject(null);
            dispatch(fetchSafetyProjects({ page: 1, pageSize: 100, ...getFilterObj(filterState) }));
          }}
        />
      )}
    </Card>
  );
};

export default List;
